/**
 * Created by Ning Jiang on 4/1/2016.
 */

import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WGSoundConfig} from "../../WGSoundConfig";
import {WGGameConfig} from "../../WGGameConfig";
import {TimelineMax} from "gsap";
import { INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {WGParsedInitData} from "../../server/data/WGParsedInitData";
import {IWinRatioConfig} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";

export class SoundManager {
    private _mode: string = "";
    private _nextMode: string = "";
    private _initData: WGParsedInitData;

    private static currentLoop: string = "";

    constructor() {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event: GameEvent) => this.onInitDataParsed(event.params[0]));

        EventHandler.addEventListener(this, ScreenEvent.GAME_READY, () => {
            if (this._mode === GameMode.FREESPIN && this._nextMode === GameMode.FREESPIN) {
                if (this._initData.superFreespin) {
                    SoundManager.playAmbientLoop(WGSoundConfig.instance.SUPER_FREE_GAME_AMBIANCE);
                } else {
                    SoundManager.playAmbientLoop(WGSoundConfig.instance.FREE_GAME_AMBIANCE);
                }
            } else {
                SoundManager.playAmbientLoop(WGSoundConfig.instance.MAIN_GAME_AMBIANCE_1);
            }
        });
    }

    private static get soundPlayer(): INolimitAudioPlayer {
        return <INolimitAudioPlayer>SlotGame.sound;
    }

    /**
     * @description When init data is parsed.
     * @param data
     */
    private onInitDataParsed(data: WGParsedInitData): void {
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._initData = data;
    }

    public static playAmbientLoop(name: string, duration?: number): void {
        this.currentLoop = name;

        this.soundPlayer.playTrack({
            name: this.currentLoop,
            volume: 1
        });

        if (duration && duration > 0){
            this.soundPlayer.fadeTrack({
                name:this.currentLoop,
                duration:duration,
                from:0,
                to:1
            })
        }

    }


    public static stopAmbientLoop(_name?: string, _duration?: number): void {
        SoundManager.stopSoundEffect(_name ? _name : this.currentLoop, _duration);
    }


    // Please NOTE the duration is in millisecond!
    public static fadeAmbienceLoop(volume: number, duration: number): void {

        this.soundPlayer.playTrack({
            name: this.currentLoop,
        });
        this.soundPlayer.fadeTrack({
            name: this.currentLoop,
            to:volume,
            duration: duration
        });
    }

    public static playSoundEffect(name: string, repeat?: number, volume?: number): void {
        this.soundPlayer.playTrack({
            name: name,
            repeat: repeat,
            volume: volume
        });
    }

    public static fadeInRainSound(): void {

        this.soundPlayer.playTrack({
            name: this.currentLoop,
            repeat: Infinity
        });


        this.soundPlayer.fadeTrack({
            name:WGSoundConfig.instance.BACKGROUND_RAIN,
            duration:500,
            from:0,
            to:1
        });
    }

    public static fadeOutRainSound(): void {
        this.stopSoundEffect(WGSoundConfig.instance.BACKGROUND_RAIN,500);
    }

    private static fadeAndStop(name: string, duration:number, to:number, from?:number){
        this.soundPlayer.fadeTrack({
            name: name,
            from:from,
            to: to,
            duration: duration
        });

        setTimeout(()=>{
            this.soundPlayer.stopTrack(name);
        }, duration)

    }

    public static stopSoundEffect(name: string, fadeOutDuration?: number): void {
        if (fadeOutDuration && fadeOutDuration > 0){
            this.fadeAndStop(name, fadeOutDuration, 0)
        } else  {
            this.soundPlayer.stopTrack(name);
        }
    }



    public static reset(): void {
        this.playAmbientLoop(WGSoundConfig.instance.MAIN_GAME_AMBIANCE_1);
    }

    /**
     * function to stop main loop and play fs loop on continue button pressup
     *
     * restore of intro, from game start
     */
    public static playFsLoop(isSuperFreeSpin: boolean): void {
        SoundManager.stopAmbientLoop(this.currentLoop);
        if (isSuperFreeSpin) {
            SoundManager.playAmbientLoop(WGSoundConfig.instance.SUPER_FREE_GAME_AMBIANCE);
        } else {
            SoundManager.playAmbientLoop(WGSoundConfig.instance.FREE_GAME_AMBIANCE);
        }
    }

    /**
     * function to stop fs loop and fade in maingame loop
     * will be called on outro Display
     */
    public static stopFsLoopFadeeInMainGameLoop(): void {
        new TimelineMax({
            onComplete: () => {
                SoundManager.stopAmbientLoop(WGSoundConfig.instance.FREE_GAME_AMBIANCE, 0);
                SoundManager.stopAmbientLoop(WGSoundConfig.instance.SUPER_FREE_GAME_AMBIANCE, 0);
                SoundManager.playAmbientLoop(WGSoundConfig.instance.MAIN_GAME_AMBIANCE_1, 2000);
            }
        }).to({}, 0.341, {});
    }

    /**
     * function to play initial win sounds
     * tiny-large
     * @param name
     * @param isScatterWin
     * @param warriorPayFeature
     * @param isBigWin
     */
    public static playInitialWinSound(name: string, isScatterWin: boolean, warriorPayFeature: boolean, isBigWin: boolean): void {
        if (warriorPayFeature) {
            SoundManager.playSoundEffect(WGSoundConfig.instance.WA_INITIAL_WIN_SOUND);
        } else if (isBigWin) {
            SoundManager.playSoundEffect(WGSoundConfig.instance.BIG_WIN_INITIAL_WIN_SOUND);
            SoundManager.fadeAmbienceLoop(0, 2500);
        } else {
            let allWinData: IWinRatioConfig[] = WGGameConfig.instance.WIN_RATIOS.normalWin;
            for (let i: number = 0; i < allWinData.length; i++) {
                if (name == allWinData[i].text) {
                    if (!warriorPayFeature && !isBigWin) {
                        SoundManager.playSoundEffect(WGSoundConfig.instance.INITIAL_WIN_SOUNDS[i]);
                    }
                    break;
                }
            }
        }
        if (isScatterWin) { // #274 is scatter is part of win play its sound
            SoundManager.playSoundEffect(WGSoundConfig.instance.INITIAL_WIN_SCATTER_SOUND);
        }
    }
}